module.exports = __webpack_public_path__ + "media/images/lock-0d53770f1ebca6896b4d9b10e88176a8.svg";